import React, { Component, createRef } from "react";

import {
    DKLabel,
    DKButton,
    DKIcons,
    DKSpinner,
    DKIcon,
    DKLine,
} from "deskera-ui-library";
import { TABLES } from "../../managers/TableManger";

import ic_contacts from "../../assets/menu/ic_user.png";
import ic_deals from "../../assets/menu/ic_deals.png";
import ic_forms from "../../assets/menu/ic_form.png";
import ic_campaign from "../../assets/menu/ic_campaign.png";
import ic_eleave from "../../assets/icons/assignment.svg";
import ic_user from "../../assets/icons/ic_user.png"
import ic_landing_page from "../../assets/menu/ic_langing_page.png";
import NotificationManager from "../../managers/NotificationManager";
import NotificationService from "../../services/NotificationService";
import payments from "../../assets/icons/payments.png"
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";

/*
PROPS
- onClose
*/

class NotificationPopup extends Component {
    constructor(props) {
        super(props);

        this.state = {
            totalCount: 0,
            notifications: null,
            loading: true
        };

        this.bottomElement = createRef();
        this.pageSize = 10;
        this.observer = null;
    }

    componentDidMount() {
        this.getNotifications(this.pageSize);

        if (this.props?.onClose) {
            document.addEventListener("mouseup", this.onMouseUp);
        }

        this.createObserver();
    }

    componentWillUnmount() {
        if (this.props?.onClose) {
            document.removeEventListener("mouseup", this.onMouseUp);
        }
    }

    componentDidUpdate() {  
        this.createObserver();
    }

    getNotifications(pageSize) {
        NotificationService.getNotifications(pageSize).then(
            (response) => {
                if (response?.data) {
                    this.setState({
                        totalCount: response.number_of_records,
                        notifications: NotificationManager.processBeforeDislay(response.data)
                    });
                } else {
                    this.setState({
                        totalCount: 0,
                        notifications: []
                    });
                }
            }, (error) => {
                this.setState({
                    totalCount: 0,
                    notifications: []
                });
            }
        );
    }

    createObserver = () => {
        const options = {
            root: document.querySelector("#notification-wrapper"),
            rootMargin: "1px",
            threshold: 1,
        };

        this.observer = new IntersectionObserver((entries, observer) => {
            if (entries[0]?.isIntersecting && entries[0]?.target === this.bottomElement.current) {
                this.onIntersectBottom();
            }
        }, options);

        if (this.bottomElement.current) {
            this.observer.observe(this.bottomElement.current);
        }
    };

    onIntersectBottom = () => {
        if (this.state.totalCount > this.pageSize) {
            this.pageSize += 10;
            this.getNotifications(this.pageSize);
        } else {
            this.setState({
                loading: false
            });
        }
    };

    onMouseUp = (e) => {
        if (this.props?.onClose) {
            const target = e.target;
            const editingContainer = target.closest("#notification-section");
            if (!editingContainer) {
                this.props?.onClose();
            }
        }
    };

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////

    closePopup = () => {
        if (this.props?.onClose) {
            this.props.onClose();
        }
    };

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////

    render() {
        const isNotificationUrl = window.location.href.split("/").pop() === "notifications";
        return (
            <>
                <div className="row justify-content-between mb-s">
                    <div className="row" style={{ width: "auto" }}>
                        <DKLabel text={`Notifications ${this.getUnreadCount()}`} className="fw-m fs-l" />
                    </div>
                    {!isNotificationUrl && <div className="column" style={{ flexDirection: "row" }}>
                        <DKButton
                            icon={DKIcons.ic_open}
                            onClick={() => {
                                RouteManager.navigateToPage(PAGE_ROUTES.NOTIFICATIONS);
                                this.closePopup();
                            }}
                        />
                        <DKButton
                            icon={DKIcons.ic_close}
                            onClick={() => {
                                this.closePopup();
                            }}
                        />
                    </div>}
                </div>

                <div className="overflow-scroll hide-scroll-bar" style={{ maxHeight: "72vh", overflow: "scroll" }}>
                    {this.state.notifications && this.state.notifications.length > 0 && this.renderAllNotifications()}
                    {this.state.loading && <DKSpinner iconClassName="ic-s-2 mb-m " className="ml-m" />}
                </div>
                {this.state.notifications && this.state.notifications.length === 0 && this.renderNoDataView()}
                {this.state.notifications === null && !this.state.loading && this.renderLoader()}
            </>
        );
    }
    getUnreadCount() {
        let count = 0;
        if (this.state.notifications) {
            this.state.notifications.forEach(notification => {
                if (!notification.read) {
                    count = count + 1;
                }
            })
        }
        return count ? `(${count})` : ''
    }

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////

    renderAllNotifications() {
        const arr = [];

        this.state.notifications.forEach((notification, index) => {
            arr.push(this.renderNotifcation(notification, index));
        });
        arr.push(<div ref={this.bottomElement} id="notification-bottom-ref" className="row parent-width" style={{ height: "2px" }}></div>);

        // Mark as read notifications once rendered
        NotificationService.getNotificationsAndMarkAllAsRead();

        return arr;
    }

    renderNotifcation(data, index) {
        return (
            <div className="parent-width">
                <DKLine className="m-v-s" />
                <div
                    className="parent-width p-s  border-box border-radius-m listPickerBG cursor-hand"
                    onClick={() => {
                        this.closePopup();
                        NotificationManager.navigateToRespectiveSection(data, index);
                    }}
                >
                    <div className="row">
                        <DKIcon className="ic-s mr-m border-m border-radius-m p-s bg-gray1" src={this.getNotificationTypeIcon(data.type)}/>
                        <div className="column parent-width">
                            <div className="row justify-content-between">
                                <DKLabel
                                    text={data.read ? data.owner : data.owner + " •"}
                                    className={
                                        "fw-m " + (data.read ? "text-dark-gray" : "text-blue")
                                    }
                                />
                                <DKLabel
                                    text={data.date}
                                    className="text-gray fs-s"
                                    style={{
                                        whiteSpace: 'nowrap',
                                        marginBottom: 'auto'
                                    }}
                                />
                            </div>
                            <DKLabel text={data.title} className="text-gray mt-xs" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////

    renderNoDataView() {
        return (
            <DKLabel text="No notifications" className="pt-xxl pb-xxl text-gray text-align-center"/>
        );
    }

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////

    renderLoader() {
        return <DKSpinner className="pt-xxl pb-xxl" />;
    }

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////

    getNotificationTypeIcon(type) {
        switch (type) {
            case TABLES.CONTACT:
                return ic_contacts;
            case TABLES.DEAL:
                return ic_deals;
            case TABLES.FORM:
                return ic_forms;
            case TABLES.LANDING_PAGE:
                return ic_landing_page;
            case TABLES.CAMPAIGN:
                return ic_campaign;
            case TABLES.PAYROLL:
                return payments
            case 'eLeave':
                return ic_eleave;
            case TABLES.EMPLOYEE_LIST:
                return ic_user;
            case TABLES.PEOPLE_EMAIL_TEMPLATE:
                return ic_landing_page;
            default:
                return DKIcons.ic_notification;
        }
    }

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////
}

export default NotificationPopup;
